import { Button } from "../common";
import { useLocalePath } from "../../hooks/useLocalePath";

const AuthContainer = ({ children }) => {
  const lp = useLocalePath();
  return (
    <main className="w-full min-h-screen bg-[#EFF3FF] py-[52px]">
      <div className="w-[83%] mx-auto h-full">
        <div className="flex flex-row">
          <Button
            variant="outline-primary"
            label="Back to Home"
            icon="mdi:arrow-left"
            to={lp("/")}
            className="py-3 px-5 rounded-[10px] font-semibold lg:mx-0 mx-auto lg:mb-0 mb-[50px]"
          />
        </div>
        <div className="w-[90%] lg:max-w-[450px] mx-auto h-full flex flex-col items-center justify-center gap-10">
          <img
            src="/icons/logo.svg"
            alt="logo"
            className="w-[130px] h-[117px] object-cover"
          />
          {children}
        </div>
      </div>
    </main>
  );
};

export default AuthContainer;
